import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";

import { BigPicture, BPComparison, Common, Subjects } from "../../../helper";
import * as bigPictureApi from "../../../api/bigPictureApi";
import { isEmptyArray } from "../../../util";
import { setPupilFilterInfo } from "../../../store/pupilProgressSlice";

import "../../../assets/stlyes/BigPicture/FilterComponent.scss";

const FilterComponent = (props) => {
  const { filterGroup, setSelectedClassName, isSubject, disableUpdate } = props;

  const updatedFilterGroup_ = useSelector((state) => state.pupilProgress.pupilFilter.info);
  const compSelected = useSelector((state) => state.pupilProgress.BPComparisonSelect)
  const dispatch = useDispatch();
  const [subject, setSubject] = useState(1);
  const [send, setSend] = useState(1);
  const [gender, setGender] = useState(2);
  const [eal, setEal] = useState(2);
  const [pp, setPp] = useState(2)
  const [year0, setYear0] = useState(true);
  const [year1, setYear1] = useState(false);
  const [year2, setYear2] = useState(false);
  const [year3, setYear3] = useState(false);
  const [year4, setYear4] = useState(false);
  const [year5, setYear5] = useState(false);
  const [year6, setYear6] = useState(false);
  const [classes, setClasses] = useState();
  // const [selectedClass, setSelectedClass] = useState(Common.All);
  // const [selectedYear, setSelectedYear] = useState([1, 2, 3, 4, 5, 6]);
  const [enableGender, setEnableGender] = useState(false);
  const [enableEal, setEnableEal] = useState(false);
  const [enablePP, setEnablePP] = useState(false);
  const [enableYear, setEnableYear] = useState(false);
  const [enableSen, setEnableSen] = useState(false);
  const [count, setCount] = useState(0);
  const selectRef = useRef(null);

  const maskSelection = () => {
    const updatedFilterGroup = { ...updatedFilterGroup_ };
    if (compSelected === BPComparison.Gender) {
      updatedFilterGroup.male = false; updatedFilterGroup.female = false; updatedFilterGroup.unspecified = true; setEnableGender(true); setEnableEal(false); setEnablePP(false); setGender(2); setEnableYear(false); setEnableSen(false);
    }
    else if (compSelected === BPComparison.EAL) {
      updatedFilterGroup.EAL = false; updatedFilterGroup.allEAL = true; updatedFilterGroup.notEAL = false; setEnableGender(false); setEnableEal(true); setEnablePP(false); setEal(2); setEnableYear(false); setEnableSen(false);
    }
    else if (compSelected === BPComparison.PP) {
      updatedFilterGroup.PP = false; updatedFilterGroup.allPP = true; updatedFilterGroup.notPP = false; setEnableGender(false); setEnableEal(false); setEnablePP(true); setPp(2); setEnableYear(false); setEnableSen(false);
    }
    else if (compSelected === BPComparison.Year) {
      setYear0(true); setYear1(false); setYear2(false); setYear3(false); setYear4(false); setYear5(false); setYear6(false); getClassByYear(); setEnableGender(false); setEnableEal(false); setEnablePP(false); setEnableYear(true); setEnableSen(false);
    }
    else if (compSelected === BPComparison.SEND) {
      updatedFilterGroup.sendSupport = true; updatedFilterGroup.notSen = true; updatedFilterGroup.ehcp = true; setSend(1); setEnableGender(false); setEnableEal(false); setEnablePP(false); setEnableYear(false); setEnableSen(true);
    }
    else {
      setEnableGender(false); setEnableEal(false); setEnablePP(false); setEnableYear(false); setEnableSen(false);
    }
    dispatch(setPupilFilterInfo(updatedFilterGroup))
  }

  const updateValue = (value) => {
    const updatedFilterGroup = { ...updatedFilterGroup_ };
    let year = parseInt(value.target.value)
    updatedFilterGroup.subjectName = year === 1 ? Common.All : year === 2 ? Subjects.Maths : year === 3 ? Subjects.Reading : year === 4 ? Subjects.Writing : year === 5 ? Subjects.Science : year === 6 ? Subjects.PE : Common.All
    setSubject(value.target.value)
    dispatch(setPupilFilterInfo(updatedFilterGroup))
  }

  const selectedSendSupports = (e) => {
    const updatedFilterGroup = { ...updatedFilterGroup_ };
    let send = parseInt(e);
    switch (send) {
    case 1: updatedFilterGroup.sendSupport = true; updatedFilterGroup.notSen = true; updatedFilterGroup.ehcp = true;
      break;
    case 2: updatedFilterGroup.sendSupport = true; updatedFilterGroup.notSen = false; updatedFilterGroup.ehcp = true;
      break;
    case 3: updatedFilterGroup.sendSupport = true; updatedFilterGroup.notSen = false; updatedFilterGroup.ehcp = false;
      break;
    case 4: updatedFilterGroup.sendSupport = false; updatedFilterGroup.notSen = false; updatedFilterGroup.ehcp = true;
      break;
    case 5: updatedFilterGroup.sendSupport = false; updatedFilterGroup.notSen = true; updatedFilterGroup.ehcp = false;
      break;
    default: updatedFilterGroup.sendSupport = true; updatedFilterGroup.notSen = true; updatedFilterGroup.ehcp = true;
      break;
    }dispatch(setPupilFilterInfo(updatedFilterGroup))
  }

  const updateYear = (i) => {
    const updatedFilterGroup = { ...updatedFilterGroup_ };
    switch (i) {
    case 0:
      setYear0(true); setYear1(false); setYear2(false); setYear3(false); setYear4(false); setYear5(false); setYear6(false);
      break;
    case 1:
      setYear0(false); setYear1(!year1);
      break;
    case 2:
      setYear0(false); setYear2(!year2);
      break;
    case 3:
      setYear0(false); setYear3(!year3);
      break;
    case 4:
      setYear0(false); setYear4(!year4);
      break;
    case 5:
      setYear0(false); setYear5(!year5);
      break;
    case 6:
      setYear0(false); setYear6(!year6);
      break;
    default: setYear0(true); setYear1(false); setYear2(false); setYear3(false); setYear4(false); setYear5(false); setYear6(false);
      break;
    }

    // Below Code is to set default selection as a All class in class dropdown whenever any other year option is clicked.
    updatedFilterGroup.classId = Common.All;//Setting classId as All 
    dispatch(setPupilFilterInfo(updatedFilterGroup))
    if (selectRef.current) {
      selectRef.current.selectedIndex = 0;//Making dropdown to select 1st option
    }
    setSelectedClassName("");
    setButtonBackground(i)
  }

  const setButtonBackground = (i) => {
    let background = "";
    switch (i) {
    case 0: background = year0 ? "yearButtonsSelected" : "yearButtons";
      break;
    case 1: background = year1 ? "yearButtonsSelected" : "yearButtons"
      break;
    case 2: background = year2 ? "yearButtonsSelected" : "yearButtons"
      break;
    case 3: background = year3 ? "yearButtonsSelected" : "yearButtons"
      break;
    case 4: background = year4 ? "yearButtonsSelected" : "yearButtons"
      break;
    case 5: background = year5 ? "yearButtonsSelected" : "yearButtons"
      break;
    case 6: background = year6 ? "yearButtonsSelected" : "yearButtons"
      break;
    default: background = "yearButtons"
    }
    return background;
  }
  useEffect(() => {
    if (count !== 0) getClassByYear();
  }, [year0, year1, year2, year3, year4, year5, year6])

  let year = []
  const getClassByYear = async () => {
    const updatedFilterGroup = { ...updatedFilterGroup_ };
    if (year0) { year = [1, 2, 3, 4, 5, 6] }
    if (year1) { year.push(1); }
    if (year2) { year.push(2) }
    if (year3) { year.push(3) }
    if (year4) { year.push(4) }
    if (year5) { year.push(5) }
    if (year6) { year.push(6) }
    // setSelectedYear(year);
    if (year.length === 0 || year.length === 6) updateYear(0);
    const classes = await bigPictureApi.getClassByYear({ year: year.length == 0 ? [1, 2, 3, 4, 5, 6] : year });
    updatedFilterGroup.pupilYear = year
    if (!isEmptyArray(classes.Items)) {
      const _classes = classes.Items.map(item => ({ value: item.classId, label: item.className }))
      setClasses([{ value: Common.All, label: Common.AllClasses }, ..._classes]);
    }
    dispatch(setPupilFilterInfo(updatedFilterGroup))
  }

  const handleClassChange = (e) => {
    const updatedFilterGroup = { ...updatedFilterGroup_ };
    updatedFilterGroup.classId = e.target.value;
    dispatch(setPupilFilterInfo(updatedFilterGroup))
    // setSelectedClass(e.target.value);
    setSelectedClassName(e.target.options[e.target.selectedIndex].label);
  };

  const genderSelection = (i) => {
    return (parseInt(i) === gender ? "selected" : "notSelected");
  }

  const updateSelectedGender = (i) => {
    let selectedGender = parseInt(i);
    const updatedFilterGroup = { ...updatedFilterGroup_ };
    switch (selectedGender) {
    case 1: updatedFilterGroup.male = true; updatedFilterGroup.female = false; updatedFilterGroup.unspecified = false;
      break;
    case 2: updatedFilterGroup.male = false; updatedFilterGroup.female = false; updatedFilterGroup.unspecified = true;
      break;
    case 3: updatedFilterGroup.male = false; updatedFilterGroup.female = true; updatedFilterGroup.unspecified = false;
      break;
    default: updatedFilterGroup.male = false; updatedFilterGroup.female = false; updatedFilterGroup.unspecified = true;
      break;
    }
    dispatch(setPupilFilterInfo(updatedFilterGroup))
  }

  const ealSelection = (i) => {
    return (parseInt(i) === eal ? "selected" : "notSelected");
  }

  const updateSelectedEal = (i) => {
    const updatedFilterGroup = { ...updatedFilterGroup_ };
    let selectedEal = parseInt(i);
    switch (selectedEal) {
    case 1: updatedFilterGroup.EAL = false; updatedFilterGroup.allEAL = false; updatedFilterGroup.notEAL = true;
      break;
    case 2: updatedFilterGroup.EAL = false; updatedFilterGroup.allEAL = true; updatedFilterGroup.notEAL = false;
      break;
    case 3: updatedFilterGroup.EAL = true; updatedFilterGroup.allEAL = false; updatedFilterGroup.notEAL = false;
      break;
    default: updatedFilterGroup.EAL = false; updatedFilterGroup.allEAL = true; updatedFilterGroup.notEAL = false;
      break;
    }
    dispatch(setPupilFilterInfo(updatedFilterGroup))
  }

  const ppSelection = (i) => {
    return (parseInt(i) === pp ? "selected" : "notSelected");
  }

  const updateSelectedPP = (i) => {
    const updatedFilterGroup = { ...updatedFilterGroup_ };
    let selectedPP = parseInt(i);
    switch (selectedPP) {
    case 1: updatedFilterGroup.PP = false; updatedFilterGroup.allPP = false; updatedFilterGroup.notPP = true;
      break;
    case 2: updatedFilterGroup.PP = false; updatedFilterGroup.allPP = true; updatedFilterGroup.notPP = false;
      break;
    case 3: updatedFilterGroup.PP = true; updatedFilterGroup.allPP = false; updatedFilterGroup.notPP = false;
      break;
    default: updatedFilterGroup.PP = false; updatedFilterGroup.allPP = true; updatedFilterGroup.notPP = false;
      break;
    }
    dispatch(setPupilFilterInfo(updatedFilterGroup))
  }

  const getClasses_ = async () => {
    const classes = await bigPictureApi.getClassByYear({ year: year.length == 0 ? [1, 2, 3, 4, 5, 6] : year });
    if (!isEmptyArray(classes.Items)) {
      const _classes = classes.Items.map(item => ({ value: item.classId, label: item.className }))
      setClasses([{ value: Common.All, label: Common.AllClasses }, ..._classes]);
    }
  }

  useEffect(() => {
    dispatch(setPupilFilterInfo({ ...filterGroup }))
    year = [1, 2, 3, 4, 5, 6]
    getClasses_();
    setCount(1)
  }, [])

  useEffect(() => {
    if (count !== 0) maskSelection();
  }, [compSelected])

  return (
    <div className="filterMain">
      {/* Subject Filter */}
      <Row className="filterMainHeading">
        <span className="heading">{Common.Filters}</span>
      </Row>
      {isSubject && <Row className="filterMainSubject d-flex align-items-center">
        <div className="subjectMain"><span className="subjectMainHeading">{Common.Subjects}</span></div>
        <div className="sliderMain">
          <div className="d-flex slidecontainerSubjectNames">
            {BigPicture.Subjects.map((subject, i) => (<div key={i} className="subjectOptionsDiv"><span className="slidecontainerSubjectNamesSubject">{subject}</span></div>))}
          </div>
          <div className="slidecontainer"><input type="range" min="1" max="6" onInput={updateValue} value={subject} className="slider" id="myRange" /></div>
        </div>
      </Row>}
      {/* Year Filter */}
      <Row className="filterMainYear">
        {enableYear ? <div className="enableYearMain"><div className="yearSelection" style={{ width: "auto" }}>
          <div className="year"><span className="yearHeading">{Common.YearGroups}</span></div>
          <div className="yearButtonSelection">{BigPicture.Years.map((year, i) => (<button key={i} className={setButtonBackground(i)} onClick={() => updateYear(i)}><span className="years">{year}</span></button>))}</div>
        </div></div> : <div className="yearSelection">
          <div className="year"><span className="yearHeading">{Common.YearGroups}</span></div>
          <div className="yearButtonSelection">{BigPicture.Years.map((year, i) => (<button key={i} className={setButtonBackground(i)} onClick={() => updateYear(i)}><span className="years">{year}</span></button>))}</div>
        </div>}
        <div className="classesDropdown">
          <select ref={selectRef} onChange={handleClassChange}>{classes && classes.map((class_, i) => (<option key={i} value={class_.value} label={class_.label}>{class_.label}</option>))}</select>
        </div>
      </Row>
      {/* Send Filter */}
      <Row className="filterMainSend d-flex align-items-center">
        <div className="sendMain"><span className="sendMainHeading">{Common.SEND}</span></div>
        {enableSen ? <div className="enableSenMain"><div className="sliderMain" style={{ width: "auto" }}>
          <div className="d-flex slidecontainerSends">
            {BigPicture.SendStatus.map((send, i) => (<div key={i} className="sendOptionsDiv"><span className="slidecontainerSendStatus">{send}</span></div>))}
          </div>
          <div className="slidecontainer"><input type="range" min="1" max="5" onInput={(e) => { selectedSendSupports(e.target.value); setSend(e.target.value) }} value={send} className="slider" id="myRange" /></div>
        </div></div> : <div className="sliderMain">
          <div className="d-flex slidecontainerSends">
            {BigPicture.SendStatus.map((send, i) => (<div key={i} className="sendOptionsDiv"><span className="slidecontainerSendStatus">{send}</span></div>))}
          </div>
          <div className="slidecontainer"><input type="range" min="1" max="5" onInput={(e) => { selectedSendSupports(e.target.value); setSend(e.target.value) }} value={send} className="slider" id="myRange" /></div>
        </div>}
      </Row>
      {/* Other Filters */}
      <Row className="filterMainOthers" style={{ marginLeft: disableUpdate ? "10%" : "" }}>
        <Col>
          {enableGender ? (<div className="enableMain"><div className="genderFilterMain">
            <div className="genderMain"><span className="genderHeading">{Common.Gender}</span></div>
            <div className="othersSlidecontainer">
              <div className="genderSpecify">{BigPicture.GenderSpecification.map((gender_, i) => (<span className={genderSelection(i + 1)} key={i}>{gender_}</span>))}</div>
              <input type="range" min="1" max="3" onInput={(e) => { setGender(parseInt(e.target.value)); updateSelectedGender(e.target.value) }} value={gender} className="slider" id="myRange" />
            </div>
          </div></div>) : (<div className="genderFilterMain">
            <div className="genderMain"><span className="genderHeading">{Common.Gender}</span></div>
            <div className="othersSlidecontainer">
              <div className="genderSpecify">{BigPicture.GenderSpecification.map((gender_, i) => (<span className={genderSelection(i + 1)} key={i}>{gender_}</span>))}</div>
              <input type="range" min="1" max="3" onInput={(e) => { setGender(parseInt(e.target.value)); updateSelectedGender(e.target.value) }} value={gender} className="slider" id="myRange" />
            </div>
          </div>)}
        </Col>
        <Col>
          {enableEal ? (<div className="enableMain"><div className="ealFilterMain">
            <div className="ealMain"><span className="ealHeading">{Common.Eal}</span></div>
            <div className="othersSlidecontainer">
              <div className="ealSpecify">{BigPicture.EalSpecifications.map((eal, i) => (<span className={ealSelection(i + 1)} key={i}>{eal}</span>))}</div>
              <input type="range" min="1" max="3" onInput={(e) => { setEal(parseInt(e.target.value)); updateSelectedEal(e.target.value) }} value={eal} className="slider" id="myRange" />
            </div>
          </div></div>) : (<div className="ealFilterMain">
            <div className="ealMain"><span className="ealHeading">{Common.Eal}</span></div>
            <div className="othersSlidecontainer">
              <div className="ealSpecify">{BigPicture.EalSpecifications.map((eal, i) => (<span className={ealSelection(i + 1)} key={i}>{eal}</span>))}</div>
              <input type="range" min="1" max="3" onInput={(e) => { setEal(parseInt(e.target.value)); updateSelectedEal(e.target.value) }} value={eal} className="slider" id="myRange" />
            </div>
          </div>)}
        </Col>
        <Col>
          {enablePP ? (<div className="enableMain"><div className="ppFilterMain">
            <div className="ppMain"><span className="ppHeading">{Common.PP}</span></div>
            <div className="othersSlidecontainer">
              <div className="ppSpecify">{BigPicture.PpSpecifications.map((pp, i) => (<span className={ppSelection(i + 1)} key={i}>{pp}</span>))}</div>
              <input type="range" min="1" max="3" onInput={(e) => { setPp(parseInt(e.target.value)); updateSelectedPP(e.target.value) }} value={pp} className="slider" id="myRange" />
            </div>
          </div></div>) : (<div className="ppFilterMain">
            <div className="ppMain"><span className="ppHeading">{Common.PP}</span></div>
            <div className="othersSlidecontainer">
              <div className="ppSpecify">{BigPicture.PpSpecifications.map((pp, i) => (<span className={ppSelection(i + 1)} key={i}>{pp}</span>))}</div>
              <input type="range" min="1" max="3" onInput={(e) => { setPp(parseInt(e.target.value)); updateSelectedPP(e.target.value) }} value={pp} className="slider" id="myRange" />
            </div>
          </div>)}
        </Col>
      </Row>
    </div>
  )
}

export { FilterComponent }